angular.module("vgresiduos").controller("ResidueMarketRedirectCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/redirect`);
		};
	}
]);
